(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Jump", [], factory);
	else if(typeof exports === 'object')
		exports["Jump"] = factory();
	else
		root["Jump"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return webpackJsonpJump([1],[],[45]);
});


// WEBPACK FOOTER //
// stores.dcbb0be14a1cd33a64dae98dce42c7f995b2dffb.js